import { render, staticRenderFns } from "./review-copy.vue?vue&type=template&id=d27cd718&"
import script from "./review-copy.vue?vue&type=script&lang=ts&"
export * from "./review-copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports